import { useState } from 'react';

import { HorizontalContainer } from '@american-autonomy/ag-ui';

import SearchFilters from 'components/SearchFilters';
import FilterButton from 'components/buttons/FilterButton';

import useTranslation from './hooks/useTranslation';

import { DEFAULT_FILTER, FILTER_KEYS, TEST_ID } from './constants';
import type { FilterKey, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DronesToolbar: FunctionComponent<Props> = ({
    className = '',
    onSearch,
    testId = TEST_ID
}) => {
    const { ALL, GROUNDED } = useTranslation();

    const [selectedFilter, setSelectedFilter] = useState<FilterKey>(DEFAULT_FILTER);

    const filterLabels: Record<FilterKey, string> = {
        all: ALL,
        grounded: GROUNDED
    };

    return (
        <HorizontalContainer className={`${className} ${styles.dronesToolbar}`} testId={testId}>
            <HorizontalContainer className={styles.filters}>
                {FILTER_KEYS.map(key => (
                    <FilterButton
                        hasValue={selectedFilter === key}
                        key={key}
                        onClick={() => setSelectedFilter(key)}
                        text={filterLabels[key]}
                    />
                ))}
            </HorizontalContainer>

            <SearchFilters className={styles.searchFilters} onSearch={onSearch} />
        </HorizontalContainer>
    );
};

export default DronesToolbar;
